import vars from '../helpers';

const links = document.querySelectorAll('[href^="#"]');
const headerOverlay = vars.header.querySelector('.header__overlay');
const headerNav = vars.header.querySelector('.header__nav');
const headerBurger = vars.header.querySelector('.header__burger');
const menuContainer = vars.menu.querySelectorAll('.menu__container');
const menuOverlay = vars.menu.querySelector('.menu__overlay');
const menuClose = vars.menu.querySelector('.menu__close');
const homeSectionIntro = vars.home.querySelector('.home__section--intro');
const elementFade = document.querySelectorAll('[data-animate]');
const popupLabel = vars.popup.querySelectorAll('.popup__label');
const buttonPopup = document.querySelectorAll('.button-popup');
const popupForm = vars.popup.querySelector('.popup__form');
const popupOverlay = vars.popup.querySelector('.popup__overlay');
const popupClose = vars.popup.querySelector('.popup__close');
const popupInput = vars.popup.querySelectorAll('input');
const popupSubmit = vars.popup.querySelector('.button-submit');
let popupInputNameFlag = false;
let popupInputEmailFlag = false;
let animateDuration = 0.5;
let animateFlag = true;
let animateTl = gsap.timeline();

const scrollTo = (current) => {
	gsap.to(window, {
		delay: 0.15,
		duration: 0.7,
		scrollTo: current,
		ease: 'Power1.easeInOut',
	});
};

const animateMenuOpen = () => {
	animateTl.from(menuOverlay, {
		onStart() {
			vars.html.classList.add('no-scroll');
			vars.menu.classList.remove('is-hidden');
		},
		duration: animateDuration / 2,
		opacity: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	}).from(menuContainer, {
		onComplete() {
			vars.menu.classList.add('is-animate');
		},
		duration: animateDuration,
		x: '100%',
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const animateMenuClose = () => {
	animateTl.to(menuContainer, {
		duration: animateDuration,
		x: '100%',
		ease: 'Power1.easeOut',
	}).to(menuOverlay, {
		duration: animateDuration / 2,
		opacity: 0,
		ease: 'Power1.easeOut',
	}).to([menuContainer, menuOverlay], {
		onComplete() {
			vars.html.classList.remove('no-scroll');
			vars.menu.classList.add('is-hidden');
			vars.menu.classList.remove('is-animate');
		},
		duration: 0,
		clearProps: 'all',
	});
};

const animatePopupOpen = () => {
	animateTl.from(popupOverlay, {
		onStart() {
			vars.popup.classList.remove('is-hidden');
		},
		onComplete() {
			vars.html.classList.add('no-scroll');
		},
		duration: animateDuration / 2,
		opacity: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	}).from(popupForm, {
		onComplete() {
			vars.popup.classList.add('is-animate');
		},
		duration: animateDuration,
		y: -100,
		opacity: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const animatePopupClose = () => {
	animateTl.to(popupForm, {
		duration: animateDuration,
		y: 100,
		opacity: 0,
		ease: 'Power1.easeOut',
	}).to(popupOverlay, {
		onStart() {
			vars.html.classList.remove('no-scroll');
		},
		duration: animateDuration / 2,
		opacity: 0,
		ease: 'Power1.easeOut',
	}).to([popupForm, popupOverlay], {
		onComplete() {
			vars.popup.classList.add('is-hidden');
			vars.popup.classList.remove('is-animate');
		},
		duration: 0,
		clearProps: 'all',
	});
};

const animateFade = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	const elementDelay = element.dataset.animateDelay ? element.dataset.animateDelay : false;

	gsap.timeline().to(element, {
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: animateDuration,
		delay: elementDelay ? elementDelay : 0,
		opacity: 1,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const animateFadeDown = (element) => {
	if (element.classList.contains('is-animate')) {
		return;
	}

	const elementDelay = element.dataset.animateDelay ? element.dataset.animateDelay : false;

	gsap.timeline().to(element, {
		onComplete() {
			element.classList.add('is-animate');
		},
		duration: animateDuration,
		delay: elementDelay ? elementDelay : 0,
		opacity: 1,
		y: 0,
		ease: 'Power1.easeOut',
		clearProps: 'all',
	});
};

const popupFormSubmit = () => {
	animatePopupClose();
};

const popupFormFilter = () => {
	let name;
	let email;

	popupInput.forEach((input) => {
		if (input.dataset.name === 'name') {
			name = vars.regex.name.test(input.value) ? true : false;
		}

		if (input.dataset.name === 'email') {
			email = vars.regex.email.test(input.value) ? true : false;
		}
	});

	if (name && email) {
		popupFormSubmit();
	} else {
		popupLabel.forEach((label) => {
			if (label.classList.contains('popup__label--name') && !name) {
				label.classList.add('is-error');
			}

			if (label.classList.contains('popup__label--email') && !email) {
				label.classList.add('is-error');
			}
		});
	}
};

const observeInit = () => {
	const observers = new IntersectionObserver((entries, observer) => {
		entries.forEach((element) => {
			if (element.isIntersecting && animateFlag) {
				observer.unobserve(element.target);

				if (element.target.dataset.animate === 'fade') {
					animateFade(element.target);
				}

				if (element.target.dataset.animate === 'fade-down') {
					animateFadeDown(element.target);
				}
			}
		});
	}, {threshold: 0.3});

	elementFade.forEach((element) => {
		observers.observe(element);
	});
};

const eventInit = () => {
	window.addEventListener('scroll', () => {
		if (!headerOverlay.classList.contains('is-animate') && window.pageYOffset > vars.header.offsetHeight) {
			headerOverlay.classList.add('is-animate');
		} else if (headerOverlay.classList.contains('is-animate') && window.pageYOffset < vars.header.offsetHeight) {
			headerOverlay.classList.remove('is-animate');
		}

		if (!vars.isMobile() && !headerNav.classList.contains('is-animate') && window.pageYOffset >= homeSectionIntro.offsetHeight - 20) {
			headerNav.classList.add('is-animate');
		} else if (!vars.isMobile() && headerNav.classList.contains('is-animate') && window.pageYOffset <= homeSectionIntro.offsetHeight - 20) {
			headerNav.classList.remove('is-animate');
		}
	});

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			scrollTo(link.getAttribute('href'));

			if (vars.menu.classList.contains('is-animate')) {
				animateMenuClose();
			}
		});
	});

	headerBurger.addEventListener('click', () => {
		animateMenuOpen();
	});

	menuOverlay.addEventListener('click', () => {
		animateMenuClose();
	});

	menuClose.addEventListener('click', () => {
		animateMenuClose();
	});

	popupLabel.forEach((label) => {
		label.addEventListener('focus', () => label.classList.add('is-focus'), true);
		label.addEventListener('blur', () => label.querySelector('[name]').value === '' ? label.classList.remove('is-focus') : '', true);
	});

	buttonPopup.forEach((button) => {
		button.addEventListener('click', () => {
			if (vars.menu.classList.contains('is-animate')) {
				animateMenuClose();
			}

			animatePopupOpen();
		});
	});

	popupOverlay.addEventListener('click', () => {
		animatePopupClose();
	});

	popupClose.addEventListener('click', () => {
		animatePopupClose();
	});

	popupInput.forEach((input) => {
		input.addEventListener('input', () => {
			if (input.dataset.name === 'name') {
				popupInputNameFlag = input.value ? true : false;

				if (input.closest('label').classList.contains('is-error')) {
					input.closest('label').classList.remove('is-error');
				}
			}

			if (input.dataset.name === 'email') {
				popupInputEmailFlag = input.value ? true : false;

				if (input.closest('label').classList.contains('is-error')) {
					input.closest('label').classList.remove('is-error');
				}
			}

			if (popupInputNameFlag && popupInputEmailFlag) {
				popupSubmit.removeAttribute('disabled');
			} else {
				popupSubmit.setAttribute('disabled', true);
			}
		});
	});

	popupSubmit.addEventListener('click', () => {
		popupFormFilter();
	});
};

document.addEventListener('DOMContentLoaded', () => {
	observeInit();
	eventInit();
});
